import React, { useState, useEffect } from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Legend, Tooltip, ResponsiveContainer } from 'recharts';

import { PostDataAPI } from '../../../Services/APIService';
import { GetUserInfo } from "../../../Services/GetUserInfo";
import DialogLoader from '../../../components/Loader/DialogLoader';

const OrderChartBar = () => {

    let user_info = JSON.parse(GetUserInfo());

    const [accountNumber] = useState(user_info.user.accountNumber);

    const [data, setData] = useState([]);
    const [loading, setIsLoading] = useState(false);

    const getShortMonthName = (fullMonthName) => {
        const date = new Date(Date.parse(`${fullMonthName} 1, 2000`));
        return date.toLocaleString("default", { month: "short" });
    }

    const formatNumber = (value) => {
        // Format the value with comma separators
        const formattedValue = value.toLocaleString();

        return formattedValue;
    };


    const loadUsageDetails = () => {
        var obj = {
            accountNumber: accountNumber
        };
        PostDataAPI("telispire/getAccountUsageDetails", obj, true).then((result) => {
            setIsLoading(false);
            if (result.success && result.data != null) {
                setData(
                    result.data.map((item, i) => {
                        item.name = getShortMonthName(item.billCycleName.split('-')[0]) + " " + item.billCycleName.split('-')[1];
                        item.Calls = item.voiceMinutes;
                        item.International = item.roamingMinutes;
                        item.Internet = item.internetUsage * 1024;
                        item.SMS = item.sMSMessages;
                        return { ...item }
                    }));
                
            } else {
            }
        })
    }


    useEffect(() => {
        if (accountNumber > 0) {
            setIsLoading(true)
            loadUsageDetails();
        }

    }, [])


    if (loading) {
        return <>
            <div style={{ position: 'relative', minHeight: window.isMobileView ? 300 : 400 }}>
                <DialogLoader />
            </div>
        </>
    }
    return (
        <ResponsiveContainer width="85%" height={window.isMobileView ? 300 : 400} className="responsive-chart">
            <BarChart height={window.isMobileView ? 310 : 400} data={data}>
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="name" />
                <YAxis tickFormatter={formatNumber} />
                <Tooltip formatter={formatNumber} />
                <Legend />
                <Bar dataKey="Internet" fill="#0049A3" stroke="rgba(75, 192, 192, 1)" />
                <Bar dataKey="Calls" fill="#0686D8" stroke="rgba(255, 99, 132, 1)" />
                <Bar dataKey="SMS" fill="#D47838" stroke="rgba(255, 205, 86, 1)" />
                <Bar dataKey="International" fill="#843C9F" stroke="rgba(54, 162, 235, 1)" />
            </BarChart>
        </ResponsiveContainer>


    );
};

export default OrderChartBar;